import type { XYChartChartLegendProps } from '../types/xy-chart.js';

export const Legend = (props: XYChartChartLegendProps) => null;

Legend['displayName'] = 'XYChartChart.Legend';
